var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.436 0H.477A.484.484 0 0 0 0 .49v5.74c0 .27.214.49.477.49h1.959c.263 0 .477-.22.477-.49V.49c0-.27-.214-.49-.477-.49",
    fill: "currentColor",
    mask: "url(#9axiw655hb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.704 .52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.363 4.25H2.936s.74-.895 1.06-2.192c.154-.62-.003-1.507-.323-1.867a.566.566 0 0 0-.975.252L2.397 1.65a2.56 2.56 0 0 1-.667 1.187L.324 4.249l-.138.141A.572.572 0 0 0 0 4.808v5.633c0 .309.243.559.544.559h3.448c1.082 0 2.028-.747 2.306-1.821l.966-3.725c.157-.608-.289-1.205-.9-1.205",
    fill: "currentColor",
    mask: "url(#nydffvshmd)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.9160b0e370005d74a21a469ec7de040b.svg";
export { ForwardRef as ReactComponent };